const Status = ["UPCOMING", "ONGOING", "COMPLETED"] as const;
const Audience = ["FAMILY", "ADULTS_18", "ADULTS_21"] as const;
const Food = ["NONE", "BREAKFAST", "HALF", "ALL"] as const;
const Accessibility = ["WHEELCHAIR", "PET", "PARKING", "WIFI"] as const;
const Transportation = ["TRANSPORTATION", "AIRPORT"] as const;
const Guides = ["TOUR", "ENGLISH"] as const;

export const Trip = {
  Status: Status,
  Audience: Audience,
  Food: Food,
  Accessibility: Accessibility,
  Transportation: Transportation,
  Guides: Guides,
};
export type Trip = {
  Status: typeof Status;
  Audience: typeof Audience;
  Food: typeof Food;
  Accessibility: typeof Accessibility;
  Transportation: typeof Transportation;
  Guides: typeof Guides;
};
